import React from 'react';

const FreeShippingBar = ({ shippingBarAmount, shippingBarText, percentage, place }) => {
    if (shippingBarText === null || percentage === null ||
      shippingBarText === '' || percentage === '') {
        return null;
    }

    const barClassName = `shipping-bar__bar ${place === 'cart' ? 'shipping-bar__cart' : ''} ${place === 'checkout' ? 'shipping-bar__checkout' : ''}`;

    percentage = percentage > 100 ? 100 : percentage;

    return (
        <div className={barClassName}>
            <div className="shipping-bar__text">
                {shippingBarText && 
                    <>
                          {shippingBarAmount &&
                            <span className="shipping-bar__red-text">{shippingBarAmount}</span>
                          }
                          &nbsp;<span>{shippingBarText}</span>
                    </>
                }
            </div>

            {percentage !== null &&
                <div className="free-shipping-bar">
                    <div className="free-shipping-bar__fill" style={{ width: `${percentage}%` }}></div>
                </div>
            }
        </div>
    );
};
  
export default FreeShippingBar;
